import { render, staticRenderFns } from "./AddSalesTarget.vue?vue&type=template&id=504e46dc&"
import script from "./AddSalesTarget.vue?vue&type=script&lang=js&"
export * from "./AddSalesTarget.vue?vue&type=script&lang=js&"
import style0 from "./AddSalesTarget.vue?vue&type=style&index=0&id=504e46dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions,QBtn,QInnerLoading,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions,QBtn,QInnerLoading})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
